import Users from './UsersStore';

const Stores = {
  userstore: new Users(),
};

export default Stores;
